import { combineReducers } from 'redux';
import theme from './slices/themeSlice';
import auth from './slices/authSlice';
import softDelete from './slices/softDeleteSlice';
import { candidatosApi } from '../services/CandidatosApi';
import { estudiosApi } from 'services/EstudiosApi';
import { trabajosEjApi } from 'services/TrabajosEjApi';
import { areasEjeApi } from 'services/AreasEjeApi';
import { cargosApi } from 'services/CargosApi';
import { carrerasApi } from 'services/CarrerasApi';
import { clientesApi } from 'services/ClientesApi';
import { comunasApi } from 'services/ComunasApi';
import { entrevistasSicoApi } from 'services/EntrevistasSicoApi';
import { entrevistasOCApi } from 'services/EntrevistasOCApi';
import { estadosCandidatosApi } from 'services/EstadosCandidatosApi';
import { estadosCivilesApi } from 'services/EstadosCivilesApi';
import { estadosProcesosApi } from 'services/EstadosProcesosApi';
import { generosApi } from 'services/GenerosApi';
import { gobCargosApi } from 'services/GobCargosApi';
import { gobUnidadesApi } from 'services/GobUnidadesApi';
import { idiomasApi } from 'services/IdiomasApi';
import { industriasApi } from 'services/IndustriasApi';
import { institucionesApi } from 'services/InstitucionesApi';
import { nivelesIdiomasApi } from 'services/NivelesIdiomasApi';
import { paisesApi } from 'services/PaisesApi';
import { procesosApi } from 'services/ProcesosApi';
import { regionesApi } from 'services/RegionesApi';
import { tiposEstudiosApi } from 'services/TiposEstudiosApi';
import { trabajosEmApi } from 'services/TrabajosEmApi';
import { trabajosGobiernoApi } from 'services/TrabajosGobiernoApi';
import { uploadApi } from 'services/UploadApi';
import { estadosCandidatosPrApi } from 'services/EstadosCandidatosPrApi';
import { prCandidatosApi } from 'services/PrCandidatosApi';
import { personalidadesApi } from 'services/PersonalidadesApi';
import { usuariosApi } from 'services/UsuariosApi';
import { perfilesApi } from 'services/PerfilesApi';
import { consentimientosDatosPersonalesApi } from 'services/ConsentimientosDatosPersonalesApi';
import { plantillasConsentimientosApi } from 'services/PlantillasConsentimientosApi';

const rootReducer = asyncReducers => (state, action) => {
	const combinedReducer = combineReducers({
		theme,
		auth,
		softDelete,
		[candidatosApi.reducerPath]: candidatosApi.reducer,
		[estudiosApi.reducerPath]: estudiosApi.reducer,
		[trabajosEjApi.reducerPath]: trabajosEjApi.reducer,
		[areasEjeApi.reducerPath]: areasEjeApi.reducer,
		[cargosApi.reducerPath]: cargosApi.reducer,
		[carrerasApi.reducerPath]: carrerasApi.reducer,
		[clientesApi.reducerPath]: clientesApi.reducer,
		[comunasApi.reducerPath]: comunasApi.reducer,
		[entrevistasSicoApi.reducerPath]: entrevistasSicoApi.reducer,
		[entrevistasOCApi.reducerPath]: entrevistasOCApi.reducer,
		[estadosCandidatosApi.reducerPath]: estadosCandidatosApi.reducer,
		[estadosCivilesApi.reducerPath]: estadosCivilesApi.reducer,
		[estadosProcesosApi.reducerPath]: estadosProcesosApi.reducer,
		[generosApi.reducerPath]: generosApi.reducer,
		[gobCargosApi.reducerPath]: gobCargosApi.reducer,
		[gobUnidadesApi.reducerPath]: gobUnidadesApi.reducer,
		[idiomasApi.reducerPath]: idiomasApi.reducer,
		[industriasApi.reducerPath]: industriasApi.reducer,
		[institucionesApi.reducerPath]: institucionesApi.reducer,
		[nivelesIdiomasApi.reducerPath]: nivelesIdiomasApi.reducer,
		[paisesApi.reducerPath]: paisesApi.reducer,
		[procesosApi.reducerPath]: procesosApi.reducer,
		[regionesApi.reducerPath]: regionesApi.reducer,
		[tiposEstudiosApi.reducerPath]: tiposEstudiosApi.reducer,
		[trabajosEmApi.reducerPath]: trabajosEmApi.reducer,
		[trabajosGobiernoApi.reducerPath]: trabajosGobiernoApi.reducer,
		[uploadApi.reducerPath]: uploadApi.reducer,
		[estadosCandidatosPrApi.reducerPath]: estadosCandidatosPrApi.reducer,
		[prCandidatosApi.reducerPath]: prCandidatosApi.reducer,
		[personalidadesApi.reducerPath]: personalidadesApi.reducer,
		[usuariosApi.reducerPath]: usuariosApi.reducer,
		[perfilesApi.reducerPath]: perfilesApi.reducer,
		[consentimientosDatosPersonalesApi.reducerPath]:
			consentimientosDatosPersonalesApi.reducer,
		[plantillasConsentimientosApi.reducerPath]:
			plantillasConsentimientosApi.reducer,
		...asyncReducers,
	});
	return combinedReducer(state, action);
};

export default rootReducer;
